export function Landing() {
  return (
    <section className="landing">
      <h1 className="landing__mark">k162</h1>
      <button
        type="button"
        className="landing__login"
        onClick={() => {
          window.location.href = "/api/auth/login";
        }}
      >
        Log in with EVE
      </button>
    </section>
  );
}
